<span class="log-time tabular">{{ entry().timestamp | date:'HH:mm:ss' }}</span>
@if (variant() === 'request') {
    <span class="log-origin">{{ entry().origin }}</span>
}
<app-expandable-message [text]="entry().message" />
